export enum TrainingStatus {
  Ready = 'ready',
  InProgress = 'inprogress',
  Completed = 'completed',
  Failed = 'failed',
  Expired = 'expired',
}

export enum DocumentType {
  FAQ = 'faq',
  Wiki = 'wiki',
  Product = 'product',
  KnowledgeArticle = 'knowledge-article',
}

export enum ThirdPartySource {
  TopDesk = 'topdesk',
  Zendesk = 'zendesk',
  Sharepoint = 'sharepoint',
  SharepointPages = 'sharepoint_pages',
  Rompslomp = 'Rompslomp',
  None = 'none',
}

export { LLMBlockTargetField } from '@conversed/shared/src/central/types/blocks/LLMBlock';

export const DOCUMENT_TYPES = Object.keys(DocumentType).map((key) => ({
  value: DocumentType[key as keyof typeof DocumentType],
  description: key,
}));

// Numeric ranking tiers stored on vector documents and data sources.
// Lower number = higher retrieval priority.
// Null means no tier (subfolders, unknown folders).
export const RankingTier = {
  Priority: 0,
  Train: 1,
  Temporary: 2,
  Core: 3,
} as const;

export type TRankingTier = (typeof RankingTier)[keyof typeof RankingTier];
